import { z } from "zod";

/**
 * Request body for `POST /api/coach-manager/private-hires/search`. Mirrors
 * `PrivateHireSearchCriteria` (`src/lib/coach-manager/types.ts`) field-for-
 * field — `buildPrivateHireSearchEnvelope` fills the WSDL-required defaults
 * for the two ID fields and the three search operators, so every criteria
 * field stays optional here too. `pickupDate`/`pickupDateOperator` is the
 * one field `contractSearchRequestSchema` doesn't have.
 */
export const privateHireSearchRequestSchema = z.object({
  buInstanceId: z.string().min(1, "This field is required"),
  privateHireId: z.number().int().optional(),
  privateHireMovementId: z.number().int().optional(),
  pickupDate: z.string().optional(),
  pickupDateOperator: z.enum(["GreaterThan", "EqualTo", "LessThan"]).optional(),
  pickup: z.string().optional(),
  destination: z.string().optional(),
  clientReference1: z.string().optional(),
  clientReference2: z.string().optional(),
  clientId: z.string().optional(),
  surname: z.string().optional(),
  initials: z.string().optional(),
  company: z.string().optional(),
  postCode: z.string().optional(),
  dateCreated: z.string().optional(),
  dateCreatedOperator: z.enum(["GreaterThan", "EqualTo", "LessThan"]).optional(),
  lastUpdated: z.string().optional(),
  lastUpdatedOperator: z.enum(["GreaterThan", "EqualTo", "LessThan"]).optional(),
});

export type PrivateHireSearchRequest = z.infer<typeof privateHireSearchRequestSchema>;
